export default __webpack_public_path__ + "static/media/play_button_vector_vso.fde6ca9b.svg";